import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
export const getHublessUserInfo = () => {
  return noPortalApiClient.get('/login-verify/user-info').then(({
    user,
    actingUserId
  }) => {
    return {
      gates: [],
      portal: {},
      user: {
        acting_user_id: actingUserId,
        created_at: 0,
        email: user.emails[0],
        first_name: user.firstName,
        lang_enabled: user.languageEnabled,
        last_name: user.lastName,
        locale: user.locale,
        partner: false,
        scopes: [],
        teams: [],
        user_id: user.id,
        verified: user.verifiedAt !== null,
        emails: user.emails,
        roles: []
      }
    };
  });
};